import { createSlice } from "@reduxjs/toolkit";
import { act } from "react";

const reportSlice = createSlice({
    name: "report",
    initialState: {
        isLoading: false,
        reportTableList: [],
        reportTableLeaveRights: [],
        reportTableWoringTime: [],
        searchAbsenceReport: [],
        reportTableWoringTime2: [],
        reportTableSalary: [],
        reportEmployeeEarningTable: [],
        rePortTableOvertime: [],
        reportSection50BisTable: [],
        reportSection50BisTable2: [],
        reportWarningLetter: [],
        reportSSOPayroll: [],
        reportEmpUnderLabour: [],
        reportExpenseRequestCompany: [],
        reportFund: [],
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setReportTableList(state, action) {
            state.reportTableList = action.payload;
        },
        setReportTableLeaveRights(state, action) {
            state.reportTableLeaveRights = action.payload;
        },
        setReportTableWorkingTime(state, action) {
            state.reportTableWoringTime = action.payload;
        },
        setSearchAbsenceReport(state, action) {
            state.searchAbsenceReport = action.payload;
        },
        setReportTableWorkingTime2(state, action) {
            state.reportTableWoringTime2 = action.payload;
        },
        setReportTableSalary(state, action) {
            state.reportTableSalary = action.payload;
        },
        setPositionOptions(state, action) {
            state.positionOptions = action.payload
        },
        setWorkInLocationList(state, action) {
            state.workInLocationList = action.payload
        },
        setReportEmployeeEarningList(state, action) {
            state.reportEmployeeEarningTable = action.payload
        },
        setReportOvertimeList(state, action) {
            state.rePortTableOvertime = action.payload
        },

        setReportSection50BisList(state, action) {
            state.reportSection50BisTable = action.payload
        },
        setReportSection50BisList2(state, action) {
            state.reportSection50BisTable2 = action.payload
        },
        setReportWarningLetterList(state, action) {
            state.reportWarningLetter = action.payload
        },
        setReportSSOPayrollList(state, action) {
            state.reportSSOPayroll = action.payload
        },
        setReportExpenseRequestCompany(state, action) {
            state.reportExpenseRequestCompany = action.payload
        },
        setReportEmpUnderLabourList(state, action) {
            state.reportEmpUnderLabour = action.payload
        },
        setReportFundList(state, action) {
            state.reportFund = action.payload
        },
    },
});

export const {
    setIsLoading,
    setReportTableList,
    setReportTableLeaveRights,
    setReportTableWorkingTime,
    setReportTableWorkingTime2,
    setSearchAbsenceReport,
    setReportTableSalary,
    setPositionOptions,
    setWorkInLocationList,
    setReportEmployeeEarningList,
    setReportOvertimeList,
    setReportSection50BisList,
    setReportExpenseRequestCompany,
    setReportWarningLetterList,
    setReportSSOPayrollList,
    setReportEmpUnderLabourList,
    setReportSection50BisList2,
    setReportFundList
} = reportSlice.actions;
export default reportSlice.reducer;